module.exports = __webpack_public_path__ + "img/vegetable-summer-squash-350x184.3570238d.jpg";